import L from 'leaflet';
import React, { memo } from 'react';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import 'react-leaflet-markercluster/styles';

const createClusterCustomIcon = (cluster: any) => {
	const size = 44;
	const anchor = size / 2;

	return L.divIcon({
		html: `<span class="cluster-count">${cluster.getChildCount()}</span>`,
		className: 'marker-cluster-custom',
		iconSize: L.point(size, size, true),
		iconAnchor: L.point(anchor, anchor, true),
	});
};

const MarkerClusterWrapper = ({ children }: { children: React.ReactNode }) => (
	<MarkerClusterGroup
		showCoverageOnHover={false}
		spiderLegPolylineOptions={{ opacity: 0 }}
		spiderfyDistanceMultiplier={2.5}
		iconCreateFunction={createClusterCustomIcon}
	>
		{children}
	</MarkerClusterGroup>
);

export default memo(MarkerClusterWrapper, () => true);
